import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(frontend)/properties/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/NearbySimilarHomes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/PhotosAndDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/PropertyAddress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/PropertyContactInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/PropertyDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SoloPropretyComponents/PropertyFeatures.tsx");
